import React from "react";
import { Route, Routes } from "react-router-dom";
import FormSalarie from "./Form/FormSalarie";
import ListSalarie from "./List/ListSalarie";
import ListDocumentForOneBySalarie from "../ListDocumentForOneSalarie/ListDocumentForOneSalarie";
import ListFile from "../File/File";
import Folder from "../Folder/Folder";

const Salarie = () => {
  return (
    <div className="salarie">
      <Routes>
        <Route path="/" exact element={<ListSalarie />} />
        <Route path="/new" exact element={<FormSalarie />} />
        <Route path="/edit/:id" exact element={<FormSalarie />} />
        <Route path="/*" exact element={<div>Erreur</div>} />
        <Route
          path="/view/documents/:id"
          exact
          element={<ListDocumentForOneBySalarie />}
        />
        <Route path="/:id/folder/*" element={<Folder />} />
        <Route path="/:salarieId/folder/:id/files/*" element={<ListFile />} />
      </Routes>
    </div>
  );
};

export default Salarie;
